import script from "./NewsPageRubricsList.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageRubricsList.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageRubricsList.vue?vue&type=style&index=0&id=7c138fac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c138fac"]])

export default __exports__